export const levels = Array.from({ length: 50 }, (_, index) => ({
    id: index + 1,
    gridWidth: 8,
    gridHeight: 8,
    targetScore: 500 + index * 50, // 500 to 2950
    moves: Math.max(30 - Math.floor(index / 10), 15), // 30 to 15 moves
    obstacles: index > 5 ? Array.from({ length: Math.min(Math.floor(index / 5), 10) }, () => [
      Math.floor(Math.random() * 8),
      Math.floor(Math.random() * 8),
    ]) : [],
  }));